import TomSelect from "tom-select/dist/cjs/tom-select.popular";
const initMunicipalitySelect = () => {
  const el = document.querySelector('[name="user[select_fields][municipality_region_province]"]');
  if (!el || el.tomselect) return;
  const currentValue = el.value;
  fetch("/comuni_regioni_province.json").then((r) => r.json()).then((data) => {
    const options = [
      {
        label: "Risiedo all'estero",
        value: "Risiedo all'estero"
      }
    ].concat(data.filter((row) => {
      var _a;
      return (_a = row["Comune"]) == null ? void 0 : _a.trim();
    }).map((row) => {
      const comune = row["Comune"].trim();
      const provincia = (row["Provincia"] || "").trim();
      const regione = (row["Regione"] || "").trim();
      const label = [comune, provincia, regione].filter(Boolean).join(" - ");
      const value = JSON.stringify({ comune, provincia, regione });
      return { label, value };
    }));
    const ts = new TomSelect(el, {
      valueField: "value",
      labelField: "label",
      searchField: "label",
      options,
      allowEmptyOption: true,
      maxItems: 1,
      create: false,
      placeholder: "Seleziona il tuo comune"
    });
    if (currentValue) {
      ts.setValue(currentValue, true);
    }
  });
};
document.addEventListener("DOMContentLoaded", initMunicipalitySelect);
document.addEventListener("turbolinks:load", initMunicipalitySelect);
document.addEventListener("turbo:load", initMunicipalitySelect);
